import React from "react";
import { Tile, BigNum } from "./primitives";

export default function PlansRunPanel({ plans }) {
  return (
    <Tile title="Plans run" testid="tile-plans">
      <div className="grid grid-cols-2 gap-4">
        <BigNum label="Today" value={plans.today} testid="plans-today" />
        <BigNum label="7 days" value={plans.d7} testid="plans-7d" />
        <BigNum label="30 days" value={plans.d30} testid="plans-30d" />
        <BigNum label="All time" value={plans.total} testid="plans-total" />
      </div>
    </Tile>
  );
}
